<template>
  <!-- 自动审核退款 -->
  <div class="autoRefund" style="min-width:1066px">
    <div class="auto-container">
      <h4>
        自动审核退款
        <!-- <p style="background-color: #fafafa; padding: 0 12px; height: 28px;border-radius: 14px">
          <span style="position: relative; top: -13px; color: #333">当前有</span
          ><span style="position: relative; top: -13px; color: #fe4d45;margin:0 4px">0</span>
          <span <span style="position: relative; top: -13px">个退款单</span>
          <span style="position: relative; top: -13px; color: #7f85e9;margin-left:4px">待审核</span>
        </p> -->
      </h4>
      <!-- 描述 -->
      <div class="desc">
        <img src="@/assets/images/autoRefund_icon.png" alt="" class="img" />
        <span>开启自动审核退款，及时解决订单上的业务</span>
      </div>
      <!-- 头部导航栏 -->
      <div class="tabList">
        <span
          :class="{ active: tabActiveIndex == 1 }"
          @click="tabActiveIndex = 1"
          >自动审核退款</span
        >
        <span
          :class="{ active: tabActiveIndex == 2 }"
          @click="tabActiveIndex = 2"
          >审核记录</span
        >
        <span
          :class="{ active: tabActiveIndex == 3 }"
          @click="tabActiveIndex = 3"
          >短信记录</span
        >
        <i></i>
      </div>

      <!-- 自动审核退款 -->
      <autoRefundModule pageName="售后中心-自动审核退款" v-show="tabActiveIndex == 1"></autoRefundModule>
      <!-- 审核记录 -->
      <autoRefundRecord v-show="tabActiveIndex == 2"></autoRefundRecord>
      <!-- 短信记录 -->
      <autoRefundSms v-show="tabActiveIndex == 3"></autoRefundSms>
    </div>
  </div>
</template>

<script>
import autoRefundModule from "./components/autoRefundModule";
import autoRefundRecord from "./components/autoRefundRecord";
import autoRefundSms from "./components/autoRefundSms";

export default {
  components: {
    autoRefundModule,
    autoRefundRecord,
    autoRefundSms,
  },
  data() {
    return {
      // pageName:"售后中心-自动审核退款",
      tabActiveIndex: 1,
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, '自动审核退款', '售后中心', '退款中心')
  },
};
</script>

<style scoped lang="scss">
.autoRefund {
  box-sizing: border-box;
  padding: 10px 20px 45px;
  button {
    box-sizing: border-box;
    padding: 6px 12px;
    border: none;
    outline: none;
    background-color: #fff;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s;
    text-align: center;
    font-size: 14px;
  }
  .auto-container {
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    h4 {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      height: 54px;
      line-height: 53px;
      border-bottom: 1px solid #f0f0f0;
      padding-left: 28px;
      margin: 0;
      border-bottom: 1px solid #f0f0f0;
      color: #2e3458;
      font-size: 16px;
      font-weight: bold;
      p {
        margin: 0 0 0 12px;
        color: #666;
        font-size: 14px;
        font-weight: 400;
        span {
          &:first-child {
            color: #fe4d45;
          }
          &:last-child {
            color: #7f85e9;
          }
        }
      }
    }
    .desc {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 12px 16px;
      margin: 20px 30px 20px 26px;
      background-color: #f7f8fe;
      color: #666;
      font-size: 14px;
      font-weight: 400;
      .img {
        width: 28px;
        height: 28px;
        margin-right: 8px;
      }
    }
    .tabList {
      display: flex;
      box-sizing: border-box;
      padding: 0 28px;
      height: 36px;
      line-height: 35px;
      margin-top: 20px;
      color: #999;
      font-size: 14px;
      span {
        width: 106px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        vertical-align: middle;
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        border-radius: 2px 2px 0px 0px;
        border: 1px solid #dddddd;
        text-align: center;
      }
      .active {
        position: relative;
        transition: all 0.2s;
        color: #fe4d45;
        border-bottom: none;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          width: 100%;
          top: 0;
          height: 2px;
          background: #fe4d45;
          border-radius: 6px 6px 0px 0px;
        }
      }
      i {
        flex: 1;
        border-bottom: 1px solid #f6f6f6;
      }
    }
  }
}
</style>